// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 152 ? "invite" : chunkId) + "." + {"152":"1eb8f1bb","721":"0938e8b5"}[chunkId] + ".js";
};